
import Vue from 'vue';
import FileInput from '@/components/FileInput.vue';
import { api, ImportType } from '@/services/api';

export default Vue.extend({
    components: {
        FileInput
    },
    data() {
        return {
            importedIds: [] as number[],
            lastImportedCount: null as number | null
        }
    },
    methods: {
        async exportExpenses() {
            await api.export();
        },
        async loadJson(file: File) {
            await api.importJson(file);
            this.importedIds = [];
            this.lastImportedCount = null;
        },
        async load(file: File, importType: ImportType) {
            this.importedIds = await api.import(file, importType);
            this.lastImportedCount = this.importedIds.length;
        },
        async autoTagImported() {
            await api.autoTagAll(this.importedIds);
        },
        async autoMapImported() {
            await api.autoMapAll(this.importedIds);
        },
        async clearLastBatch() {
            await api.deleteLastBatch();
            this.importedIds = [];
            this.lastImportedCount = null;
        }
    }
})
